import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	languages: [],
};

const languagesSlice = createSlice({
	name: 'languages',
	initialState,
	reducers: {
		storeLanguages: (state, action) => {
			state.languages = action.payload;
		},
	},
});

export const selectAllLanguages = (state) => {
	return state.languages;
};

export const { storeLanguages } = languagesSlice.actions;

export default languagesSlice.reducer;
